export const NotificationTemplatesTableColumns = [
    { id: "code",      labelEn: "Code",     labelAr: "الكود",     align: "left",   sortable: true },
    { id: "channel",   labelEn: "Channel",  labelAr: "القناة",    align: "center", sortable: true },
    { id: "locale",    labelEn: "Locale",   labelAr: "اللغة",     align: "center", sortable: true },
    { id: "subject",   labelEn: "Subject",  labelAr: "العنوان",   align: "left",   sortable: false },
    { id: "is_active", labelEn: "Status",   labelAr: "الحالة",    align: "center", sortable: true },
    { id: "updated_at",labelEn: "Updated",  labelAr: "آخر تحديث", align: "center", sortable: true },
];
